import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../api/api";
// import api from "../api/api";
import { FaEnvelope, FaLock } from "react-icons/fa";
// import { GoogleLogin } from "@react-oauth/google";
// import { jwtDecode } from "jwt-decode";
// import jwtDecode from "jwt-decode";
// import axios from "axios";
import "../styles/Login.css";

const Login = ({ setUserData }) => {
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await loginUser(form);
      if (response.data.user) {
        setUserData(response.data.user);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/");
      } else {
        setError(response.data.error || "Invalid credentials");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please try again.");
    }
  };

  // const handleGoogleSuccess = async (res) => {
  //   console.log("✅ onSuccess:", res);
  //   try {
  //     const resp = await loginWithGoogle(res.credential);
  //     console.log("↪ backend response:", resp.data);
  //     if (resp.data.user) {
  //       localStorage.setItem("user", JSON.stringify(resp.data.user));
  //       setUserData(resp.data.user);
  //       navigate("/");
  //     } else {
  //       setError(resp.data.error || "Login failed");
  //     }
  //   } catch (e) {
  //     console.error("🔥 loginWithGoogle error:", e);
  //     setError("Login failed—check console");
  //   }
  // };

  // const handleGoogleError = (err) => {
  //   console.error("❌ onError:", err);
  //   setError("Google login failed—see console");
  // };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>User Login</h2>
        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <FaEnvelope className="icon" />
            {/* <FaPhoneAlt className="icon icon-phone" /> */}
            <input
              type="text"
              name="identifier"
              placeholder="Email or Phone"
              value={form.identifier}
              onChange={handleChange}
              required
            />
            
          </div>
          

          <div className="input-group">
            <FaLock className="icon" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn-login">
            Login
          </button>
        </form>

        {/* <div className="divider text-center">
          <span>OR</span>
        </div>


        <div className="google-login-wrapper">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
        />
      </div>

      {error && <p className="error">{error}</p>} */}

        

        <p className="forgot">
          <Link to="/forgot-password">Forgot Password?</Link>
        </p>

        <div className="auth-footer">
          <p>
            Don't have an account? <Link to="/register">Register here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
